<template>
	<v-card :id="`${elementKey}_job_selection`" elevation="0" color="transparent" @click.stop @keydown="nextItem">
		<v-text-field
			style="position: relative"
			v-model="search"
			:color="color"
			:background-color="bgColor"
			:outlined="outlined"
			:placeholder="placeholder"
			:disabled="disabled"
			:error="error"
			dense
			hide-no-data
			hide-details
			clearable
			@click.stop="queryJobs(search)"
			@click:clear.stop="onSelected(null)"
		>
			<template v-slot:append>
				<div v-if="loading" class="load"></div>
				<v-icon v-else :disabled="disabled" :color="error ? '#F45252':'rgba(25, 42, 62, 0.7)'" @click.stop="queryJobs(search)">mdi-menu-down</v-icon>
			</template>
		</v-text-field>
		<v-card-text v-if="is_open" class="pa-0 tree-container tree-wrap" :style="`top: ${top}px;left: ${left}px; ${isWidthAuto ? `width: ${whole_width}px` : `width: ${max_width}px`}`">
			<div class="tree-wrap-container">
				<v-list-item-group
					v-if="result_list.length !== 0"
					v-model="selectedItem"
				>
					<v-list-item
						v-for="item in result_list"
						:key="item.id"
						dense
					>
						<span @click="onSelected([item])">{{ is_title ? item.display_name : item.code }}</span>
					</v-list-item>
				</v-list-item-group>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import config from "@/config.js";

const Key_Code_Up = 38;
const Key_Code_Down = 40;
const Key_Code_Enter = 13;

export default {
	name: 'JobDropdown',
	props: {
		color: {
			type: String,
			default: '#FFFFFF'
		},
		bgColor: {
			type: String,
			default: ''
		},
		jobSelected: {
			type: Object,
			default: null
		},
		outlined: {
			type: Boolean,
			default: true
		},
		placeholder: {
			type: String,
			default: ''
		},
		isWidthAuto: {
			type: Boolean,
			default: false
		},
		closeSelection: {
			type: Number,
			default: 0
		},
		disabled: {
			type: Boolean,
			default: false
		},
		elementKey: {
			type: String,
			default: '00'
		},
		is_title: {
			type: Boolean,
			default: false,
		},
		error: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return { 
			loading: false,
			is_open: false,
			search: this.jobSelected !== null ? (this.is_title ? this.jobSelected.display_name : this.jobSelected.code) : null,
			result_list: [],
			selectedItem: -1,

			max_width: 0,
			whole_width: 0,
			top: 0,
			left: 0
		}
	},
	watch: {
		jobSelected() {
			this.search = this.jobSelected !== null ? (this.is_title ? this.jobSelected.display_name : this.jobSelected.code) : null;
		},
		closeSelection() {
			this.is_open = false;
			this.result_list = [];
		},
		async search(newVal, oldVal) {
			if (newVal !== oldVal && newVal && (this.jobSelected ? (this.is_title ? newVal !== this.jobSelected.display_name : newVal !== this.jobSelected.code)  : true) ) {
				this.result_list = [];
        
				if (!this.is_open && this.result_list.length !== 0) {
					this.is_open = true;
				}
				if (this.is_open && this.result_list.length === 0) {
					this.is_open = false;
				}
				
				await this.queryJobs(newVal);
			}
		}
	},
	methods: {
		nextItem (event) {
			if (event.keyCode === Key_Code_Up && this.selectedItem > 0) {
				this.selectedItem--
			} else if (event.keyCode === Key_Code_Down && this.selectedItem < this.result_list.length) {
				this.selectedItem++
			} else if (event.keyCode === Key_Code_Enter && this.result_list.length !== 0 && this.selectedItem >= 0) {
				const item = this.result_list[this.selectedItem];
				this.onSelected([item]);
			}
		},
		async queryJobs(key) {
			if (this.disabled === true) return;

			this.result_list = [];
			const elem = document.getElementById(`${this.elementKey}_job_selection`);
			const diff_bottom = this.$vuetify.breakpoint.height - elem.getBoundingClientRect().bottom;

			this.max_width = elem.clientWidth;	
			this.whole_width = elem.parentNode.parentNode.clientWidth;

			this.top = diff_bottom >= 240 ? elem.getBoundingClientRect().bottom : (elem.getBoundingClientRect().top - 240);
			this.left = elem.getBoundingClientRect().left;
			
			this.is_open = true;

			this.loading = true;
			
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));
			params.push("status_groups=" + config.job_status_group_nomal.toString());
			params.push('is_lookup' + '=' + encodeURIComponent(false));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;
					if (status === 'OK') {
						if (key === this.search) {
							const key_upper = key.toUpperCase();

							const date_filter = data.filter(d => {
								const data_upper = this.is_title ? d.short.toUpperCase() : d.code.toUpperCase();
								return data_upper.includes(key_upper);
							});

							const items = date_filter.map(item => {
								const obj = {
									id: item.id,
									display_name: item.short,
									code: item.code,
								};
								return obj;
							});

							this.result_list = items;
						}
						
					} else {
						this.$emit('error', reason)
					}
				})
				.catch((e) => {
					this.$emit('error', e.message);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onSelected(value) {
			if (value) {
				const selected_item = value[0];
				if (!selected_item.children) {
					this.result_list = [];
					this.search = this.is_title ? value[0].display_name : value[0].code;

					setTimeout(() => {
						this.is_open = false;
					}, 300);
					
					this.$emit('job-selected', value[0]);
					this.selectedItem = -1;
				}
			} else {
				this.selectedItem = -1;
			}
		},
		
	}
}
</script>
<style lang="scss" scoped>
.tree-container {
	position: fixed;
	z-index: 12;
	background-color: #FFFFFF;
	box-shadow: 0px 1px 1px #192A3E;

	height: 240px;
	overflow-y: auto;
}
.tree-wrap {
	overflow: auto;
}
.tree-wrap-container {
  height: 99%;
}
.load {
	border: 2px solid #C4C4C4;
  border-top: 2px solid #192A3E;
	border-right: 2px solid #192A3E;
  border-radius: 50%;
  width: 20px;
  height: 20px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>